// This file is automatically generated from ingestAssets.mjs
import * as React from 'react';
import IconContainer, { IconProps } from '../../../components/IconContainer';

export function AndroidLogoBoldIcon(props: IconProps) {
	return (
		<IconContainer {...props}>
			{
				<svg
					xmlns="http://www.w3.org/2000/svg"
					width="100%"
					height="100%"
					fill="none"
					viewBox="0 0 32 32"
				>
					<path
						fill="currentColor"
						d="M22.5 19.5a2 2 0 1 1-4 0 2 2 0 0 1 4 0Zm-11-2a2 2 0 1 0 0 4 2 2 0 0 0 0-4Zm19 3.5v3a2.5 2.5 0 0 1-2.5 2.5H4A2.5 2.5 0 0 1 1.5 24v-2.859a14.669 14.669 0 0 1 4.215-10.305L2.939 8.061a1.503 1.503 0 1 1 2.125-2.125l2.974 2.98a14.294 14.294 0 0 1 7.91-2.416H16c2.84-.008 5.619.825 7.986 2.393l2.953-2.954a1.502 1.502 0 1 1 2.125 2.125l-2.75 2.75A14.397 14.397 0 0 1 30.5 21Zm-3 0A11.5 11.5 0 0 0 15.959 9.5C9.64 9.523 4.5 14.75 4.5 21.141V23.5h23V21Z"
					/>
				</svg>
			}
		</IconContainer>
	);
}
